<template lang="pug">
shListData(title="Métodos de Pago" resolver="methods" keyData="method" component="shMethod")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Methods',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/method/Methods.vue